import React, { useState, useEffect } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import Controls from "../../components/FormsUI";
import { useAuth } from "../../utility/auth";
import UserController from "../../controller/UserController";//controller/UserController
import MedicalCenterController from "../../controller/MedicalCenterController";
import MastersController from "../../controller/MastersController";
import CustomizedSnackbars from "../../components/Alert";
import EditIcon from "@mui/icons-material/Edit";
import Load from "../../components/FormsUI/Loader/index";//../components/FormsUI/Loader/index
import DeleteIcon from "@mui/icons-material/Delete";
import "../../css/style.css";
import { tokens } from "../../theme";
import {
  Container,
  Grid,
  useTheme,
  Box,
  Stack,
  IconButton,
  Radio,
  FormControlLabel,
} from "@mui/material";
import ExceptionHandlerController from "../../controller/ErrorLogsController";
const numberRegEx = /^[0-9\b]+$/;
// const INITIAL_FORM_STATE = {
//   userName: "",
//   userType: "",
//   userRoleId: "",
//   userReportingRole: "",
//   employeeCode: "",
//   email: "",
//   mobile: "",
//   requiresLogin: "",
//   referralLink: "",
//   referralURL: "",
//   userBranchName: "",
//   servicesMapped: [],
//   password: "",
// };

// const FORM_VALIDATION = Yup.object().shape({
//   userName: Yup.string()
//     .matches(/^[A-Za-z ]*$/, "User name is not in correct format")
//     .trim("No white space allowed")
//     .strict(true)
//     .min(3)
//     .max(100, "Name should not be exceed 50 Character")
//     .required("User name is required"),
//   userType: Yup.string().required("User type is required"),
//   userRoleId: Yup.string().required("Role is required"),
//   userReportingRole: Yup.string().required("Reporting user is required"),
//   employeeCode: Yup.string()
//     .min(2)
//     .max(20, "Employee Code should not be exceed 20 Character")
//     .trim("No white space allowed")
//     .strict(true)
//     .matches(/^[A-Za-z0-9]*$/, "Employee code is not in correct format")
//     .required("Employee code is required"),
//   email: Yup.string()
//     .trim("No white space allowed")
//     .strict(true)
//     .email("Invalid Email Id")
//     .required("Email Id is required"),
//   mobile: Yup.number()
//     .required("Mobile is required")
//     .min(1000000000, "Invalid mobile number")
//     .max(9999999999, "Invalid mobile number"),
//   requiresLogin: Yup.boolean().required("Requires login is required"),
//   userBranchName: Yup.string()
//     .min(3)
//     .max(100, "BranchName should not be exceed 100 Character")
//     .trim("No white space allowed")
//     .strict(true)
//     .matches(/^[A-Za-z ]*$/, "Branch name is not in correct format")
//     .required("Branch name is required"),
//   password: Yup.string().when("requiresLogin", {
//     is: true,
//     then: Yup.string()
//       .trim("No white space allowed")
//       .strict(true)
//       .max(30, "BranchName should not be exceed 30 Character")
//       .matches(
//         /^[a-zA-Z0-9!@#$%^&*.]{8,30}$/,
//         "password must be of at least 8 characters, password must not have spaces in between begining or end, Valid values for passwords include numerals, capital letters, !, @, #, $, %, ^, &, or *. No other special characters are allowed."
//       )
//       .required("Password is required"),
//     otherwise: Yup.string().optional().nullable(),
//   }),
// });
// let roles = [];
// let reportingRoles = [];


const INITIAL_FORM_STATE = {
  centerLongName: "",
  centerShortName: "",
  centerAddress1: "",
  centerAddress2: "",
  city: "",
  state: "",
  pincode: "",
  telephone: "",
  centerFromTime: "",
  centerToTime: "",
  centerOpenOn: "",
};

const FORM_VALIDATION = Yup.object().shape({
  centerLongName: Yup.string()
    .matches(/^[A-Za-z ]*$/, "Center Long Name is not in correct format")
    .trim("No white space allowed")
    .strict(true)
    .min(3, "Minimum 3 characters required")
    .max(100, "Name should not exceed 100 characters")
    .optional(),
  centerShortName: Yup.string()
    .matches(/^[A-Za-z ]*$/, "Center Short Name is not in correct format")
    .trim("No white space allowed")
    .strict(true)
    .min(2, "Minimum 2 characters required")
    .max(50, "Name should not exceed 50 characters")
    .optional(),
  centerAddress1: Yup.string()
    .min(5, "Minimum 5 characters required")
    .max(200, "Address should not exceed 200 characters")
    .optional(),
  centerAddress2: Yup.string()
    .max(200, "Address should not exceed 200 characters")
    .optional(),
  city: Yup.string()
    .matches(/^[A-Za-z ]*$/, "city name is not in correct format")
    .optional(),
  state: Yup.string().optional(),
  pincode: Yup.string()
    .matches(/^[0-9]{6}$/, "pincode must be 6 digits")
    .test("len", "pincode must be exactly 6 digits", (val) =>
      val && val.toString().length === 6
    )
    .optional(),
  telephone: Yup.string()
    .matches(/^[0-9]{10}$/, "Telephone must be 10 digits")
    .test("Tlen", "Telephone must be exactly 10 digits", (val) =>
      val && val.toString().length === 10
    )
    .optional(),
  centerFromTime: Yup.string().required("From time is required"),
  centerToTime: Yup.string().required("To time is required"),
  centerOpenOn: Yup.string().required("Center Open On is required"),
});


let requestType = "";
const MedicalCenter = () => {
  const medicalCenterController = new MedicalCenterController();
  const exceptionHandlerController = new ExceptionHandlerController();
  const auth = useAuth();
  const user = auth.decoder(sessionStorage.getItem("user"));
  const { data, token } = user;
  const { userid: userId, tenantid: tenantId } = data.UserInfo;
  const [medicalCenter, setMedicalCenter] = useState([])
  const [loader, setLoader] = useState(true);
  const [updatedValues, setUpdatedValues] = useState(INITIAL_FORM_STATE);
  const [alert, setAlert] = useState({ counter: 0, type: "", msg: "" });
  const [popup, setPopUp] = useState(false);
  const [allUsers, setAllUsers] = useState([]);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  useEffect(() => {
    getAllMedicalCenter();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getAllMedicalCenter = async () => {
    let caughtError;
    try {
      const response = await medicalCenterController.GetAllMedicalCenter(token);
      if (response.status === 200) {
        const medicalData = response?.data?.body?.map((item) => ({
          ...item,
          id: item._id,
        }));
        setMedicalCenter(medicalData);
      }
      else if (response?.data?.status === 404) {
        showAlert("error", response?.data?.message);
      } else if (response?.status === 500) {
        showAlert("error", response?.response?.data?.message);
      }
      setLoader(() => false);
    } catch (error) {
      caughtError = error;
      let logData = {};
      logData.message = caughtError?.message;
      logData.stack = caughtError?.stack;
      let logError = {
        logData,
        module: "getAllMedicalCenter",
      };
      exceptionHandlerController.HandleException(logError);
    }
  };

  const showAlert = (type, msg) => {
    const notify = { ...alert };
    notify.counter = notify.counter + 1;
    notify.type = type;
    notify.msg = msg;
    setAlert(notify);
  };

  const columns = [
    {
      headerName: "ID",
      field: "id",
      hide: true,
      filterable: false,
      width: 210,
    },
    { headerName: "Center Long Name", field: "centerLongName", width: 210 },
    { headerName: "Center Short Name", field: "centerShortName", width: 210 },
    { headerName: "Pincode", field: "pincode", width: 210 },
    { headerName: "Telephone", field: "telephone", width: 210 },
    {
      field: "action",
      headerName: "Action",
      width: 210,
      sortable: false,
      filterable: false,
      disableExport: true,
      disableClickEventBubbling: true,

      renderCell: (params) => {
        const onClick = (e, type) => {
          let caughtError;
          try {
            setAlert({ counter: 0, type: "", msg: "" });
            const currentRow = params?.row;
            if (type === "Edit") {
              requestType = "Edit";
              setUpdatedValues(() => currentRow);

              const currentRowData = currentRow;

              setUpdatedValues(() => currentRowData);
              handleData();
            } else {
              medicalCenterController
                .Delete(currentRow.id, token)
                .then((response) => {
                  if (response.status === 200) {
                    getAllMedicalCenter()
                    showAlert("success", "Deleted successfully");
                    setAllUsers((i) => {
                      return allUsers.filter(
                        (item) => item?.id !== currentRow.id
                      );
                    });
                  } else if (response.data.status === 404) {
                    showAlert("error", response.data.message);
                  }
                  else if (response?.status === 500) {
                    showAlert("error", response?.response?.data?.message);
                  }
                })
                .catch((error) => {
                  showAlert("error", "Oops something went wrong.");
                  setTimeout(() => {
                    setAlert({ counter: 0, type: "", msg: "" });
                  }, 10000);
                });
            }
          } catch (error) {
            caughtError = error;
            let logData = {};
            logData.message = caughtError?.message;
            logData.stack = caughtError?.stack;
            let logError = { logData, module: "MedicalCenter onClick(Edit) method" };
            exceptionHandlerController.HandleException(logError);
          }
        };

        return (
          <Stack direction="row" spacing={2}>
            <>
              <IconButton onClick={(e) => onClick(e, "Edit")}>
                <EditIcon type="button" color="primary" id="Edit" />
              </IconButton>
              <IconButton>
                <DeleteIcon
                  type="button"
                  color="secondary"
                  id="Delete"
                  onClick={(e) => onClick(e, "Delete")}
                />
              </IconButton>
            </>
          </Stack>
        );
      },
    },
  ];

  const AddMedicalCenter = async () => {
    requestType = "Add";
    setUpdatedValues(() => INITIAL_FORM_STATE);
    handleData();
  };

  const submitValues = (submitValueData) => {
    let submitData = {};

    // tenantId coming from parent/component
    submitData.tenantId = tenantId;

    // Map form fields
    submitData.centerLongName = submitValueData?.centerLongName?.trim();
    submitData.centerShortName = submitValueData?.centerShortName?.trim();
    submitData.centerAddress1 = submitValueData?.centerAddress1?.trim();
    submitData.centerAddress2 = submitValueData?.centerAddress2?.trim();
    submitData.city = submitValueData?.city?.trim();
    submitData.state = submitValueData?.state?.trim();

    submitData.pincode = submitValueData?.pincode;
    submitData.telephone = submitValueData?.telephone;

    submitData.centerFromTime = submitValueData?.centerFromTime;
    submitData.centerToTime = submitValueData?.centerToTime;
    submitData.centerOpenOn = submitValueData?.centerOpenOn;

    if (requestType === "Edit") {
      // debugger
      submitData.centerId = submitValueData?.id; // assuming ID comes from backend

      medicalCenterController
        .Update(submitData, token)
        .then((response) => {
          if (response.status === 200) {
            getAllMedicalCenter()
            showAlert("success", response?.data?.message);
            handlePopup(false);
            setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
          } else {
            if (response?.data?.status === 204)
              showAlert("error", response?.data?.message);
            else if (response?.response?.status === 409)
              showAlert("error", response?.response?.data?.message);
            else if (response?.status === 500)
              showAlert("error", response?.response?.data?.message);

            setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
          }
        })
        .catch((error) => {
          showAlert("error", "Oops something went wrong.");
          setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
        });
    } else {
      medicalCenterController
        .Create(submitData, token)
        .then((response) => {
          if (response?.status === 201) {
            getAllMedicalCenter()
            handlePopup(false);
            showAlert("success", response?.data?.message);
            setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
            // getAllCenters();
          } else if (response?.response?.status === 500) {
            showAlert("error", response?.response?.data?.message);
          } else if (response?.response?.status === 409) {
            showAlert("error", response?.response?.data?.message);
          }

          setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
        })
        .catch((error) => {
          showAlert("error", "Oops something went wrong.");
          setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
        });
    }
  };


  const handlePopup = (value) => setPopUp(() => value);
  const handleData = () => setPopUp(() => true);
  if (loader) return <Load />;

  return (
    <>
      <Box
        sx={{
          "& .formBg": {
            border: `1px solid ${colors.grey[900]}`,
            background: `${colors.primary[400]}`,
          },
          "& li.MuiBreadcrumbs-li h6": { color: `${colors.primary[200]}` },
          "& .MuiGrid-root.Mui-heading h2": {
            color: `${colors.primary[200]} !important`,
          },
        }}
      >
        <Grid container>
          <Grid className="breadcrumb-section">
            <Grid className="breadcrumb-container">
              <Grid className="Mui-li">
                <nav className="Mui-nav" aria-label="breadcrumb">
                  <ol className="">
                    <li className="MuiBreadcrumbs-li">
                      <h6 className="breadsub">Med</h6>
                    </li>
                    <li aria-hidden="true" className="MuiBreadcrumbs-separator">
                      /
                    </li>
                    <li className="MuiBreadcrumbs-li">
                      <h6>Medical Center</h6>
                    </li>
                  </ol>
                </nav>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={12} className="adduser">
            <Controls.ActionButton onClick={() => AddMedicalCenter()}>
              <span>Add New</span>
            </Controls.ActionButton>
          </Grid>
          <Grid item xs={12} className="formBg">
            <Container maxWidth="md" className="formClwidth">
              <div>
                <Controls.Grid
                  columns={columns}
                  data={medicalCenter}
                  fileName={"Users"}
                />
                {popup && (
                  <Controls.Popup
                    title="Medical Center Details"
                    openPopup={popup}
                    setOpenPopup={handlePopup}
                  >
                    <Formik
                      enableReinitialize
                      initialValues={{
                        ...(updatedValues || INITIAL_FORM_STATE),
                      }}
                      validationSchema={FORM_VALIDATION}
                      onSubmit={(values) => submitValues(values)}
                    >
                      {({ values, setFieldValue, handleChange }) => (
                        <Form>
                          <Grid container spacing={2}>
                            <Grid item xs={12} md={6}>
                              <Controls.Textfield
                                name="centerLongName"
                                label="Center Long Name"
                                type="string"
                                inputProps={{ maxLength: 100 }}
                              />
                            </Grid>

                            <Grid item xs={12} md={6}>
                              <Controls.Textfield
                                name="centerShortName"
                                label="Center Short Name"
                                type="string"
                                inputProps={{ maxLength: 50 }}
                              />
                            </Grid>

                            <Grid item xs={12} md={6}>
                              <Controls.Textfield
                                name="centerAddress1"
                                label="Center Address 1"
                                type="string"
                                inputProps={{ maxLength: 200 }}
                              />
                            </Grid>

                            <Grid item xs={12} md={6}>
                              <Controls.Textfield
                                name="centerAddress2"
                                label="Center Address 2"
                                type="string"
                                inputProps={{ maxLength: 200 }}
                              />
                            </Grid>

                            <Grid item xs={12} md={6}>
                              <Controls.Textfield
                                name="city"
                                label="city"
                                type="string"
                              />
                            </Grid>

                            <Grid item xs={12} md={6}>
                              <Controls.Textfield
                                name="state"
                                label="state"
                                type="string"
                              />
                            </Grid>

                            <Grid item xs={12} md={6}>
                              <Controls.Textfield
                                name="pincode"
                                label="pincode"
                                type="string"
                                inputProps={{ maxLength: 6 }}
                                onChange={(e) => {
                                  const { value } = e.target;
                                  if (/^\d*$/.test(value)) {   // only digits allowed
                                    setFieldValue("pincode", value);
                                  }
                                }}
                              />
                            </Grid>

                            <Grid item xs={12} md={6}>
                              <Controls.Textfield
                                name="telephone"
                                label="Telephone"
                                type="string"
                                inputProps={{ maxLength: 10 }}
                                onChange={(e) => {
                                  const { value } = e.target;
                                  if (/^\d*$/.test(value)) {   // ✅ only digits allowed
                                    setFieldValue("telephone", value);
                                  }
                                }}
                              />
                            </Grid>

                            <Grid item xs={12} md={6}>
                              <Controls.Textfield
                                name="centerFromTime"
                                label="From Time"
                                type="time"
                                InputLabelProps={{ shrink: true }}
                              />
                            </Grid>

                            <Grid item xs={12} md={6}>
                              <Controls.Textfield
                                name="centerToTime"
                                label="To Time"
                                type="time"
                                InputLabelProps={{ shrink: true }}
                              />
                            </Grid>

                            <Grid item xs={12} md={6}>
                              <Controls.Textfield
                                name="centerOpenOn"
                                label="Center Open On"
                                type="string"
                              />
                            </Grid>

                            <Grid item xs={4} md={2} className="marginAuto">
                              <Controls.Button>Submit</Controls.Button>
                            </Grid>
                          </Grid>
                        </Form>
                      )}
                    </Formik>
                  </Controls.Popup>
                )}

              </div>
            </Container>
          </Grid>
          {alert?.counter > 0 && (
            <CustomizedSnackbars
              status={alert?.counter}
              msg={alert?.msg}
              type={alert?.type}
            />
          )}
        </Grid>
      </Box>
    </>
  );
};

export default MedicalCenter;
